import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { contractorAuth } from '../../lib/contractorAuth';
import '../Assets.css';

/**
 * "How to reach me" (migration 063): where instructions sent to THIS person
 * should go - chat, the ticket, email, a to-do. Four tick-boxes, saved as
 * they are ticked, for the contractor on a ticket and for the member of
 * staff an instruction is for. It sits in the Instructions panel, because
 * that is where the person meets instructions; there is no settings page
 * either role would look for this on.
 *
 * `initial` is what the ticket already said about the caller's choice, so
 * the card draws at once; a change is PUT and the answer is what is shown.
 */
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const CHANNEL_WORDS = {
  chat: 'Chat', ticket: 'On the ticket', email: 'Email', todo: 'A to-do'
};

export default function DeliveryPrefs({ initial = null, authHeaders = null }) {
  const [prefs, setPrefs] = useState(initial);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');
  const config = authHeaders ? { headers: authHeaders } : contractorAuth();

  useEffect(() => {
    if (initial) { setPrefs(initial); return; }
    axios.get(`${API_BASE}/instruction-delivery`, config)
      .then((r) => setPrefs(r.data))
      .catch(() => setPrefs(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initial]);

  if (!prefs || prefs.ready === false) return null;
  const channels = prefs.channels || [];
  const toggle = async (c) => {
    const next = channels.includes(c) ? channels.filter((x) => x !== c) : [...channels, c];
    setError('');
    setSaved(false);
    setPrefs({ ...prefs, channels: next });
    try {
      const r = await axios.put(`${API_BASE}/instruction-delivery`, { channels: next }, config);
      setPrefs(r.data);
      setSaved(true);
    } catch (e) {
      setPrefs(prefs);
      setError(e.response?.data?.error || 'Could not save that.');
    }
  };

  return (
    <div className="as-reach" data-testid="delivery-prefs">
      <div className="as-reach-head">
        <strong>How to reach me</strong>
        <span className="as-quiet">
          Where an instruction sent to you goes, as well as here.
          {saved && <span className="as-reach-saved">Saved</span>}
        </span>
      </div>
      <div className="as-reach-options" role="group" aria-label="How to reach me">
        {Object.entries(CHANNEL_WORDS).map(([c, w]) => (
          <label key={c} className="as-check">
            <input type="checkbox" checked={channels.includes(c)} onChange={() => toggle(c)} />
            <span>{w}</span>
          </label>
        ))}
      </div>
      {channels.length === 0 && <p className="as-quiet" style={{ margin: '0.4rem 0 0', fontSize: '0.82rem' }}>Nothing ticked: you will see instructions on the ticket, in your bell, and from the agent, and nowhere else.</p>}
      {error && <p className="as-error" role="alert">{error}</p>}
    </div>
  );
}
